import React, { Component,Fragment } from 'react';
import Breadcrumb from "../../common/breadcrumb";
import { setRoundAvailable, setEventAvailable, reviseTUser, stopTimer, putToast, loadJudgeAvailability, AuthenticatedUser} from "../../api"
import RoundAvailabilityCube from './cubes/availability/roundAvailabilityCube';
import EventAvailabilityCube from './cubes/availability/eventAvailabilityCube';
import 'react-table/react-table.css';
import TournamentPageTemplate from './tournamentPageTemplate'

export class JudgeAvailability extends Component {
    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        const { user } = AuthenticatedUser();

        this.state = {
            loading: true,
            open: false,
            openProfileNotice: false,
            user: user,
            pid: params.pid,
            tData: {},
            mode: 'round', 
            currentTitle: null,
            parents: []
        }
    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            loadJudgeAvailability(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ pid: pid, tData: d2.tournamentPage, tUser: d2.tUser, loading: false}); 
                    this.setMode();                                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount(){
        this.loadTournamentPage();  
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params !== this.props.match.params) {
            this.setMode();
        }
    }

    setMode() {
        const {tData} = this.state;

        const { match: { params } } = this.props;
        const {roundId, eventId} = params;

        if (roundId && eventId) {
            const round = this.state.tData.rounds.find(x=>x._id === params.roundId);
            const event = round.events.find(x=>x._id === params.eventId);

            this.setState({
                mode: 'room', 
                tRound: round,
                tEvent: event,
                tRoom: null,
                currentTitle: event.title,
                parents: [ {
                    url: `${process.env.PUBLIC_URL}/tournament/availability/${tData._id}/${round._id}`,
                    name: round.title
                }]
            })
            return;
        }

        if (roundId) {
            const round = this.state.tData.rounds.find(x=>x._id === params.roundId);

            this.setState({
                mode: 'event', 
                tRound: round,
                tEvent: null,
                tRoom: null,
                currentTitle: round.title,
                parents: [ ]            
            })
            return;
        }

        this.setState({
            mode: 'round', 
            tRound: null,
            tEvent: null,
            tRoom: null,
            currentTitle: null,
            parents: []
        })
    }

    onTUserUpdate(round, event) {
        const { tUser} = this.state;
        
        if (round) {
            var tUserRound = tUser.rounds.find(x=>x.roundId === round._id);            
            if (event) {
                var tUserRoundEvent = tUserRound.events.find(x=>x.eventId === event.eventId);                
                setEventAvailable(tUserRound, tUserRoundEvent, !tUserRoundEvent.isAvailable);
            } else {
                setRoundAvailable(tUserRound, !tUserRound.isAvailable);
            }
        } 

        reviseTUser(tUser).then(d2 => {
            if (!d2 || d2.error) {
                console.log(d2 ? d2.error : "Could not update. Are you logged in?");
                putToast.error(d2 ? d2.error : "Could not update. Are you logged in?");
            } else {
                putToast.success(d2.message);
                this.setState({ tUser: d2.tUser });
            }
        });         

    }

    onRoundCubeTitleClicked(round) {
        this.props.history.push(`/tournament/availability/${this.state.tData._id}/${round._id}`)
    }

    onEventCubeTitleClicked(event) {
        this.props.history.push(`/tournament/availability/${this.state.tData._id}/${this.state.tRound._id}/${event._id}`)
    }

    onRoomCubeTitleClicked(room) {
        this.props.history.push(`/tournament/availability/${this.state.tData._id}/${this.state.tRound._id}/${this.state.tEvent._id}/${room._id}`)
    }

    renderModeSwitch() {
        const {mode, tData, tUser, tRound, user } = this.state;

        switch(mode) {
            case 'round': return  (
                <>
                    {tData.rounds.filter(x=>!x.blockJudges).map((round, index) => {                         
                        return (
                        <div key={index} className="col-xl-4 col-md-6">
                            <RoundAvailabilityCube key={index} 
                                onStatusIconClick={(checked) => this.onTUserUpdate(round, null, null, checked)} 
                                onTitleClick={() => this.onRoundCubeTitleClicked(round)} 
                                tournament={tData} round={round} user={user} tUser={tUser}
                            />
                        </div>
                        )}
                    )}
                </> )

            case 'event': return (
                <>
                    {tRound.events.map((event, index) => 
                    <div key={index} className="col-xl-4 col-md-6">
                        <EventAvailabilityCube key={index} 
                            onStatusIconClick={(checked) => this.onTUserUpdate(tRound, event, null, checked)} 
                            tournament={tData} round={tRound} event={event} tUser={tUser} user={user}
                        />
                    </div>
                    )}
                </> )

            default: return (null);
        }
    }

    render() {
        if (this.state.loading) { return null; }

        stopTimer();
        const {tData, user, currentTitle, parents } = this.state;

        const localRoot = {
            url: `${process.env.PUBLIC_URL}/tournament/availability/${tData._id}`,
            name: "Rounds"
        }

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Set Judging Availability - ${user.displayname}`} title3=""
                bcTitle="Judge Schedule" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]}
            >
                <Fragment>
                    <Breadcrumb localRoot={localRoot} title={currentTitle} parents={parents}/>
                    <div className="container-fluid">    
                        <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "25px"}}>Please single click the buttons.  Please do not double-click.</p>
            
                        <div className="row">
                        {this.renderModeSwitch()}                                                                                      
                        </div>
                    </div>                   
                </Fragment>
            </TournamentPageTemplate>
        )
    }
}

export default JudgeAvailability
